export class EntityBase {
  public CREATED_BY: string;
  public CREATED_DATE: string;
  public LAST_UPDATED_BY: string;
  public LAST_UPDATED_DATE: string;
  public ORGANIZATION_ID: string;
  public OBS_CODE: string;
  public RECORD_STATE: number;
  public LANGUAGE_ID: string;
}


export class City {
  public CITY: string;
  public COUNTRY: string;
  public STATE: string;
  public ZIP: string;
}

export class ZipData {
  public City: string;
  public State: string;
  public StateFullName: string;
  public Zip: string;
  public Country: string;
}

export class ZipResponse {
  public Status: boolean;
  public Data: ZipData;
}

export class Menu {
  public Name: string;
  public Code: string;
  public Id: string;
  public Screentype: string;
  public MenuType: string;
  public Operation: string;

}

export class Department {
  public ID: number;
  public CODE: string;
  public NAME: string;
  public RECORD_STATE: number;
}

export class SelectValue {
  constructor(value, label) {
    this.value = value;
    this.label = label;
  }
  public value: string;
  public label: string;
}

export class SCREEN_CONTROL_CONDITONS {
  public ID: string;
  public OptionValue: string;
  public Condtion: string;
  public MappedFields: any = [];
  public state: string;
  public conditionsList: dropdownsource[] = [];
  public mappedFieldsList: dropdownsource[] = [];
  public tooltip: string;
}

export class SCREEN_CONTROL {

  public ID: string;
  public SCREEN_ID: string;
  public SERIAL_NO: number;
  public LABEL: string;
  public CONTROL: string;
  public GROUP_VALUES: string;
  public GROUP_VALUES_LIST:any= [];
  public FILED_VALUES: string;
  public Control_Condtions?: Control_Dependents[] = [];

  public IS_MANDATORY: boolean = false;
  public IS_PASTDATES_ALLOWED: boolean = false;
  public is_PastDatesStr : string = "";
  public IS_MANDATORYStr: string = "";
  public STATE: number = 0;
  public ROWSTATE: string;
  public CONTROLTYPE: string;
  public STATEVALUE: string;
  public SourceItems: dropdownsource[] = [];
  public ControlValue: any = "";
  public RESPONSEID: string = null;
  public ANSWERID: string = null;
  public PURPOSE: string = "";
  public UploadFiles: Document_Upload_File[];
  public ISALLOWMULTIPLEFILES: boolean = false;
  public SUBFIELDNAME: string = "";
  public DATEFORMATE: string = "";
  public IsActive: boolean = true;
  public IsTouched: boolean = false;
  public NotimesChanged: number = 0;
  public MAXCHARACTERLENGTH: number;
  public IS_EDITABLE: boolean = false;
  public IS_DISPLAY: number = 0;
  public IS_STATIC: boolean = false;
  public RECORD_STATE: number = 0;
  public dynamicDateobj: DateObject;
  public minDat : Date;
  public IS_Dependent_Display: boolean = false;
  public IS_Dependent_Enabled: boolean = false;
  public Display_Field: boolean = false;

}

export class Control_Dependents {
  public ID?: string;
  public ControlID?: string;
  public Control_label?: string;
  public Control_Field_Code?: string;
  public Control_Type?: string;
  public Mapped_Control_Value?: string;
  public state:string;
  ConditionsList?: Control_Dependents_Details[] = [];
}

export class Control_Dependents_Details {
  public ID?: string;
  public Mapped_Condtion?: string;
  public Mapped_Controls_List?: Mapped_Control_Details[] = [];

}

export class Mapped_Control_Details {
  public ID?: string;
  public Control_Type?: string;
  public ControlID?: string;
  public Control_Field_Code?: string;

}

export class Screen {
  public ID: string;
  public CODE: string;
  public NAME: string;
  public DESCRIPTION: string;
  public SCREEN_TYPE: string;
  public MODULE_ID: string;
   public SUBMODULE: string;
  public ISCHECKED: boolean;
  public SCREEN_CONTROL: SCREEN_CONTROL[] = [];
  public Status: boolean;
  public HAS_SAVE_SUBMIT: string;
}

export class Module {
  public ID: string;
  public CODE: string;
  public NAME: string;
}

export class dropdownsource {
  public value: string;
  public label: string;
  public Checked: boolean;
  public disabled : boolean;
 public customClass :string;
}

export class ControlStateSource {
  public value: boolean;
  public label: string;
}

export class SCREEN_RESPONSE {
  public ID: string;
  public SCREEN_ID: string;
  public SCREEN_CONTROL_ID: string;
  public CONTROL_TYPE: string;
  public STATUS: string;
  public MODULE_ID: string;
  public SCREEN_RESPONSE_ANSWER: SCREEN_RESPONSE_ANSWER[] = [];
  public ROW_ID: string;
  public UploadFiles: Document_Upload_File[];
  public APPLICATION_ID: string;
  public AUDIT_LOGID: string;
  public dynamicDateobj: DateObject;
  public CREATED_BY: string;
  public SUBMIT_STATUS: number;
}

export class SCREEN_RESPONSE_ANSWER {
  public ID: string;
  public SCREEN_RESPONSE_ID: string;
  public ANSWER: string;
  public ROW_ID: number;
}

export class IST_APP {
  public ID: string;
  public APPLICATION_CODE: string;
  public APPLICATION_TYPE_ID: string;
  public PHYSICIAN_ID: string;
  public TITLE_OF_STUDY: string;
  public STATUS: number;
  public PHYSICIANNAME: string;
  public CREATEDON: string;
  public UPDATEDON: string;
  public CREATED_BY: string;
  public CREATED_BY_IST: string;
  public ISSUBMITRETURN: boolean;
  public CurrentStatusExt: string;
  public COOWNER: string;
  public HasCOOWNERPermission: boolean;
  public MappedApplicationType: string;
  public MappedWorkFlowName: string;
  public MappedCurrency: string;
  public SUBMIT_STATUS : number;
  public FLEX_FIELD_1:string;
}

export class EAP_APP {
  public ID: string;
  public APPLICATION_CODE: string;
  public APPLICATION_TYPE_ID: string;
  public PHYSICIAN_ID: string;
  public TITLE_OF_STUDY: string;
  public STATUS: number;
  public PHYSICIANNAME: string;
  public CREATEDON: string;
  public UPDATEDON: string;
  public CREATED_BY: string;
  public COOWNER: string;
  public ISSUBMITRETURN: boolean;
  public CREATED_BY_IST: string;
  public CurrentStatusExt: string;
  public HasCOOWNERPermission: boolean;
  public MappedApplicationType: string;
  public MappedWorkFlowName: string;
}

export class GM_APP {
  public ID: string;
  public STATUS: number;
  public APPLICATION_TYPE_ID: string;
  public GRANT_TYPE: number;
  public RFPID: string;
  public APPLICATION_CODE: string;
  public GRANTTYPE: string;
  public CratedDateStr: string;
  public CratedStr: string;
  public StatuStr: string;
  public PHYSICIANNAME: string;
  public CREATEDON: string;
  public UPDATEDON: string;
  public CREATED_BY: string;
  public StartMenu: string;
  public TherapeuticArea: string;
  public ISSUBMITRETURN: boolean;
  public CREATED_BY_GM: string;
  public CurrentStatusExt: string;
  public COOWNER: string;
  public HasCOOWNERPermission: boolean;
  public SubModuleNameExt: string;
  public MappedApplicationType: string;
  public MappedWorkFlowName: string;
}

export class ModuleMenu {
  public appId: string;
  public screenID: string;
  public module: string;
  public operation: string;
  public formstate: string;
  public TargetFrom: string;
}

export class RFP {
  public ID: string;
  public CODE: string;
  public NAME: string;
  public DESCRIPTION: string;
  public IS_LOI_REQUIRED: boolean;
}

export class INSTRUCTION {
  public ID: number;
  public CODE: string;
  public NAME: string;
  public DESCRIPTION: string;
  public ModuleStr: string;
  public SHOWINSTRUCTIONTOUSER: boolean;

}

export class UploadAnswer {
  constructor() {
  }

  public fileid: string;
  public filename: string;
  public status: string;
  public fileSize: number;
  public file: any;
  public sourcetype: number;
  public sectionno: number;
  public subsectionno: number;
  public questionno: number;
  public responseId: number;
  public rowid: number
}

export class Document_Upload {
  public ID: string;
  public TRANSACTION_ID: string;
  public SEQUENCE_NO: number;
  public DOCUMENT_TYPE_ID: string;
  public NOTES: string;
  public UserName: string;
  public UploadedDate: string;
  public LabelName: string;
  public SubLabelName: string;
  public IsDisplay: boolean;
  public AttachedDocID: string;
  public DocumentTypeID: string;
  public IsManadatory: boolean;
  public IsMultipleDocuments: boolean;
  public ApplicationID: string;
  public IS_UPTO_DATE: boolean;
  public UploadFiles: Document_Upload_File[];
  public DocumentTypeName: string;
  public PURPOSE :string;
}

export class Document_Upload_File {
  public ID: string;
  public TRANSACTION_ID: string;
  public FIELD_ID: string;
  public SEQUENCE_NO: number;
  public DOCUMENT_NAME: string;
  public Document_Url: string;
  public File: any;
  public Status: string;
  public UploadedDate: string;
}


export class Document_Upload_Files {
  public ID: string;
  public TRANSACTION_ID: string;
  public FIELD_ID: string;
  public SEQUENCE_NO: number;
  public DOCUMENT_NAME: string;
  public Document_Url: string;
  public File: File;
  public Status: string;
}

export class File{
  public FileID:string;
  public FileName:string;
  public Length:any;
}

export class IST_SEMINAR_SPEAKER{
  public FileNameExt: string;
  public FIST_NAME: string;
  public ID  : string;
  public LAST_NAME: string;
  public OCCUPATION: string;
  public QUALIFICATION: string;
  public TITLE: string;
  public FILES: Array<Document_Upload_Files>;
  public ScreenControlId: string;

}

export class IST_SITE_EVALUATION {
  public ID: string;
  public APPLICATION_ID: string;
  public STUDY_CENTER_ID: string;
  public EVALUATION_TYPE_ID: string;
  public REPRESENTATIVE_ID: string;
  public CONTACT_PERSON_ID: string;
  public CONTACT_PERSON_DESIGNATION: string;
  public EXPECTED_VISIT_DATE: string;
  public NOTES: string;
  public STATUS: string;
  public ASSIGN_DATE: string;
  public UploadFiles: Document_Upload_File[];
}

export class GM_RECONCILIATION {
  public EXPENDITURE_AMOUNT: number;
  public TOTAL_FEE: number;
  public REQUESTED_AMOUNT: number;
  public ALLOCATION_AMOUNT: number;
  public BALANCE: number;
  public CurrencySymbol: string;
}

export class AUTO_CODE {
  public ID: string;
  public NAME: string;
  public FEATURE_ID: string;
  public FEATURE_NAME: string;
  public MODULE_ID: string;
  public MODULE_CODE: string;
  public SUB_MODULE: string;
  public NUMBER_OF_PARTS: number;
  public SEPARATOR: string;
  public CODE_FORMAT: string;
  public AUTO_CODE_PART: AUTO_CODE_PART[];
  public RECORD_STATE: number;
  public RECORD_STATEBool: boolean;
}

export class AUTO_CODE_PART {
  constructor() {
    this.ID = "";
    this.AUTO_CODE_ID = "";
    this.PART_ORDER = 0;
    this.PART_TYPE = 0;
    this.DYNAMIC_TYPE = 0;
    this.VALUE = "";
    this.COUNTER_START_VALUE = 1;
    this.OLD_COUNTER_START_VALUE = 1;
    this.COUNTER_RESET_BY = 4;
    this.COUNTER_LENGTH = 3;

  }
  public ID: string;
  public AUTO_CODE_ID: string;
  public PART_ORDER: number;
  public PART_TYPE: number;
  public DYNAMIC_TYPE: number;
  public VALUE: string;
  public COUNTER_START_VALUE: number;
  public OLD_COUNTER_START_VALUE: number;
  public COUNTER_LENGTH: number;
  public COUNTER_RESET_BY: number;
}

export class LOOKUPMAIN {
  public ID: string;
  public categoryName: string;
  public subCategoryName: string;
  public moduleID: string;
  public organizationID: string;
  public recordState: string;
  public lookupType: string;
  public lookuplist: LOOKUP[];
}

export class LOOKUP {
  public ID: string;
  public CODE: string;
  public NAME: string;
  public LOOKUP_TYPE_ID: string;
  public SEQUENCE_NO: number;
  public RECORD_STATE: number;
  public ChildData: any = [];
}

export class UpdateLookup {
  public LookUp: LOOKUP;
  public PROGRAM: string;
  public ID: string;
  public LOOKUP_TYPE_NAME: string;
  public lookuplist: LOOKUP[];
}

export class EVENT_MASTER {
  public ID: string;
  public CODE: string;
  public NAME: string;
  public DESCRIPTION: string;
  public MODULE_ID: number;
  public TYPE_ID: number;
  public PRIORITY_ID: number;
  public TARGETED_USER: number;
  public ENABLED_FOR: number;
  public HAS_NOTIFICATION: boolean;
  public NOTIFICATION_TEMPLATE: string;
  public HAS_EMAIL: boolean;
  public EMAIL_TO_IDS: string;
  public EMAIL_CC_IDS: string;
  public EMAIL_BCC_IDS: string;
  public EMAIL_SUBJECT: string;
  public EMAIL_BODY: string;
  public PARAMETERS: string;
}

export class NotificationMessage {
  public Id: string;
  public Body: string;
}

export class EMAILCONFIG {
  public ID: string;
  public NAME: string;
  public EMAIL: string;
  public INMAILSERVER: string;
  public INCOMINGPORT: string;
  public INCONNECTIONTYPE: string;
  public OUTMAILSERVER: string;
  public OUTPORT: string;
  public OUTCONNECTIONTYPE: string;
  public USERID: string;
  public PASSWORD: string;
}

export class LDAP {
  public ID: string;
  public LDAPRVER: string;
  public LDAPPORT: string;
  public LDAPTYPE: string;
  public FILTER: string;
  public EMAIL: string;
  public USERID: string;
  public PASSWORD: string;
  public ENABLED: boolean;
}

export class SAML {
  public ID: string;
  public SIGNINURL: string;
  public SIGNOUTURL: string;
  public USERID: string;
  public PASSWORD: string;
  public CERTIFICATE: string;
  public ACSURL: string;
  public LOGINURL: string;
  public ENABLED: boolean;
}

export class CONFIGURATION {
  public EMAILCONFIG: EMAILCONFIG;
  public SAML: SAML;
  public LDAP: LDAP;
  public ID: string;
  public CONFIG_TYPE: number;
  public CONFIG_INFO: string;
  public IS_CONN_SUCCESSED: boolean;
  public Attachments: [];
}

export class PolicyXML {
  public Module: string;
  public SubModule: string;
  public States: State[];
  public Operations: Operation[];
  public ID: string;
  public CODE: string;
  public NAME: string;
  public MODULE_ID: string;
  public SUB_MODULE: string;
  public DESCRIPTION: string;
  public IS_PUBLISHED: string;
  public DEFAULT_ID: string;
  public LastModifiedBy: string;
  public LastModifiedDate: string;
  public RECORD_STATEExt: boolean;
}

export class State {
  public ID: string;
  public NAME: string;
  public OLDNAME: string;
  public SNO: number;
  public ALLOWENABLE: boolean;
  public DEFAULT_ID: number;
  public ISFIXED: boolean;
  public ISCHECKED: boolean;
  public Order: number;
  public Operations: Operation[];

  public InternalUsers: Operation[];
  public ExternalUsers: Operation[];
  public Features: Feature[];
  public IST: boolean;
  public CHARITY: boolean;
  public SPONSERSHIP: boolean;
  public CME: boolean;
  public RECORD_STATE: boolean;
  public IsReviwAvailable: boolean;
  public IsApprovalAvailable: boolean;
  public RecordStatus: string;
  public STATUSCODE: string;
}

export class Operation {
  public Code: string;
  public Name: string;
  public Type: string;
  public ISCHECKED: boolean;
  public IsDeleted: boolean;
  public Internal: boolean;
  public External: boolean;
}

export class Feature {
  public Sno: number;
  public Code: string;
  public Name: string;
  public OldName: string;
  public ScreenType: string;
  public InternalUser: string;
  public ExternalUser: string;
  public ISCHECKED: boolean;
  public RecordStatus: string;
}

export class DateObject {
  public Day?: number;
  public Month?: number;
  public Year?: number;
  public Hours?: number;
  public Minutes?: number;
  public Seconds?: number;
  public IsEndDate?: boolean;
  public HasValue?: boolean;
  public IsDateModified?: boolean;
}

export class REGCONFIG_CONTROL {
  public ID: string;
  public SCREEN_ID: string;
  public SERIAL_NO: number;
  public LABEL: string;
  public CONTROL: string;
  public GROUP_VALUES: string;
  public GROUP_VALUES_LIST: [];

  public IS_MANDATORY: boolean = false;
  public IS_MANDATORYStr: string = "";
  public STATE: number = 0;
  public ROWSTATE: string;
  public CONTROLTYPE: string;
  public STATEVALUE: string;
  public SourceItems: dropdownsource[] = [];//Array<dropdownsource>;
  public ControlValue: any = "";
  public RESPONSEID: string = null;
  public ANSWER: string = null;
  public PURPOSE: string = "";
  public FIELD_CODE: string = "";
  public PARENT_FIELD_CODE: string = "";
  public UploadFiles: Document_Upload_File[];
  public ISALLOWMULTIPLEFILES: boolean = false;
  public SUBFIELDNAME: string = "";
  public DATEFORMATE: string = "";
  public IsActive: boolean = true;
  public IsTouched: boolean = false;
  public NotimesChanged: number = 0;
  public MAXCHARACTERLENGTH: number;
  public IS_EDITABLE: boolean = false;
  public IS_DISPLAY: number = 0;
  public IS_STATIC: boolean = false;
  public dynamicDateobj: DateObject;
  public IS_NAME_EDITABLE: boolean = true;

}

export class REGCONFIG_CONTROL_RESPONSE {
  public ID: string;
  public SCREEN_ID: string;
  public SCREEN_CONTROL_ID: string;
  public CONTROL_TYPE: string;
  public STATUS: string;
  public MODULE_ID: string;
  public SCREEN_RESPONSE_ANSWER: REGCONFIG_CONTROL_ANSWER[] = [];
  public ROW_ID: string;
  public UploadFiles: Document_Upload_File[];
  public APPLICATION_ID: string;
  public AUDIT_LOGID: string;
  public dynamicDateobj: DateObject;
}


export class REGCONFIG_CONTROL_ANSWER {
  public ID: string;
  public SCREEN_RESPONSE_ID: string;
  public ANSWER: string;
  public ROW_ID: number;
}

export class DocumentUploadFile {
  public ID: string;
  public TRANSACTION_ID: string;
  public FIELD_ID: string;
  public SEQUENCE_NO: number;
  public FileName: string;
  public FileExt: string;
  public Document_Url: string;
  public File: any;
  public Status: string;
  public UploadedDate: string;
}

export class PolicyModel {
  public id: string;
  public operation: string;
  public module: string;
}

export class ScreenModel {
  public Id: string;
  public RecordState: string;
  public Name: string;
  public ModuleId: string;
}

export class DocumentModel {
  public Featureid: string;
  public Rowid: string;
  public Appid: string;
}

export class ScreenResponseModel {
  public Id: string;
  public RowId: string;
  public AppId: string;
}

export class ModuleFeatureModel {
  public Id: string;
  public Code: string;
  public State: string;
  public Operation: string;
  public TargetForm: string;
  public ApplicationTypeId: string;
}

export class Model {
  public Text: string;
  public Type: string;
  public AppId: string;
  public CurrencyID:string;
}

export class AudienceModel {
  public Text: string;
  public Type: string;
  public AppId: string;
  public AudienceGroupID: string;
  public SpecialtyID: string;
  public CreditCategoryID: string;
}

export class ReconModel {
  public Text: string;
  public Type: string;
  public AppId: string;
  public BTypeId: string;
  public BSubTypeId: string;
  public Status: any;
}

export class AdvModel {
  public Text: string;
  public Type: string;
  public AppId: string;
  public SearchText: string;
}

export class LogOutModel {
  public Reason: string;
  public Browser: string;
  public Version: string;
  public UserId: string;
}

export class APPLICATION_TYPE_BUDGET
{
  public  ID: string;
  public  STATUS: string;
  public  APPLICATION_TYPE_ID : string;
  public  OLD_ALLOCATED_BUDGET?:number;
  public  ALLOCATED_BUDGET?:number
  public  CONSUMED_AMOUNT? :number;
  public  PERCENTAGE :number;
  public AppType: any[];
}
